import React, { FC } from 'react'

import ItemContainer from './ItemContainer'

import { BoothConfigListItem, VideoData } from '../types'

const VideoItem: FC<BoothConfigListItem> = ({
    data,
    onButtonEditClick,
    onButtonDeleteClick,
}: BoothConfigListItem) => {
    const { id, name, embedded_url } = data as VideoData

    return (
        <ItemContainer
            id={id}
            onButtonEditClick={onButtonEditClick}
            onButtonDeleteClick={onButtonDeleteClick}
        >
            {name || embedded_url }
        </ItemContainer>
    )
}

export default VideoItem
